export const API_FAILURE = 'cricket/App/Data/API_FAILURE';
export const REMOVE_API_ERROR = 'cricket/App/Data/REMOVE_API_ERROR';
export const CONNECTION_ERROR = 'cricket/App/Data/CONNECTION_ERROR';
export const SET_VIEW_MODE = 'cricket/App/Data/SET_VIEW_MODE';
